import { Canvas, FabricImage } from 'fabric'

import {
  BSRE_STAMP_BASE64,
  BSRE_STAMP_HEIGHT,
  BSRE_STAMP_KEY,
  CANVAS_CONFIG,
} from '../constants'

export const findBsreStamp = (canvas: Canvas | null): FabricImage | null => {
  if (!canvas) return null
  const objects = canvas.getObjects()
  return (
    (objects.find(
      (obj) => (obj as any).customObjectType === BSRE_STAMP_KEY,
    ) as FabricImage) || null
  )
}

export const isBsreStampObject = (obj: any): boolean => {
  return obj?.customObjectType === BSRE_STAMP_KEY
}

export const removeBsreStamp = (canvas: Canvas | null) => {
  if (!canvas) return
  const stamp = findBsreStamp(canvas)
  if (stamp) {
    canvas.remove(stamp)
  }
}

export const addBsreStamp = async (canvas: Canvas | null) => {
  if (!canvas) return
  const existingStamp = findBsreStamp(canvas)
  if (existingStamp) {
    canvas.bringObjectToFront(existingStamp)
    return
  }

  const img = await FabricImage.fromURL(BSRE_STAMP_BASE64, undefined, {
    customObjectType: BSRE_STAMP_KEY,
    left: CANVAS_CONFIG.width / 2,
    top: CANVAS_CONFIG.height - BSRE_STAMP_HEIGHT / 2,
    width: CANVAS_CONFIG.width,
    height: BSRE_STAMP_HEIGHT,
    lockMovementX: true,
    lockMovementY: true,
    lockRotation: true,
    lockScalingX: true,
    lockScalingY: true,
    lockScalingFlip: true,
    hasControls: false,
    hasBorders: false,
    selectable: false,
    evented: false,
  })

  canvas.add(img)
  canvas.bringObjectToFront(img)
}

export const ensureBsreStampOnCanvas = async (
  canvas: Canvas | null,
  isUsingTte?: boolean,
): Promise<boolean> => {
  if (!canvas) return false

  let wasModified = false

  if (isUsingTte) {
    const stamp = findBsreStamp(canvas)
    if (stamp) {
      stamp.set({
        lockMovementX: true,
        lockMovementY: true,
        lockRotation: true,
        lockScalingX: true,
        lockScalingY: true,
        lockScalingFlip: true,
        hasControls: false,
        hasBorders: false,
        selectable: false,
        evented: false,
      })
      canvas.bringObjectToFront(stamp)
      canvas.requestRenderAll()
    } else {
      await addBsreStamp(canvas)
      wasModified = true
    }
  } else {
    const stamp = findBsreStamp(canvas)
    if (stamp) {
      removeBsreStamp(canvas)
      wasModified = true
    }
  }

  return wasModified
}
